import axios from 'axios';

export function clearCartItem(itemId: number | string) {
  return axios.delete(`/api/cart-item/${itemId}`).then(response => response.data);
}
